"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.apiForCurrency = void 0;
var url_1 = __importDefault(require("url"));
var invariant_1 = __importDefault(require("invariant"));
var bignumber_js_1 = require("bignumber.js");
var errors_1 = require("@ledgerhq/errors");
var json_bignumber_1 = __importDefault(require("@ledgerhq/json-bignumber"));
var network_1 = __importDefault(require("../network"));
var Ledger_1 = require("./Ledger");
var errors_2 = require("../errors");
var cache_1 = require("../cache");
var env_1 = require("../env");
var apiForCurrency = function (currency) {
    var baseURL = (0, Ledger_1.blockchainBaseURL)(currency);
    if (!baseURL) {
        throw new errors_1.LedgerAPINotAvailable("LedgerAPINotAvailable ".concat(currency.id), {
            currencyName: currency.name
        });
    }
    return {
        getTransactions: function (address, block_hash, batch_size) {
            if (batch_size === void 0) { batch_size = 2000; }
            return __awaiter(this, void 0, void 0, function () {
                var data;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, network_1["default"])({
                                method: "GET",
                                url: url_1["default"].format({
                                    pathname: "".concat(baseURL, "/addresses/").concat(address, "/transactions"),
                                    query: {
                                        batch_size: batch_size,
                                        noinput: true,
                                        no_input: true,
                                        no_token: true,
                                        filtering: true,
                                        block_hash: block_hash
                                    }
                                }),
                                transformResponse: json_bignumber_1["default"].parse
                            })];
                        case 1:
                            data = (_a.sent()).data;
                            // v3 have a bug that still includes the tx of the paginated block_hash, we're cleaning it up
                            if (block_hash) {
                                data = __assign(__assign({}, data), { txs: data.txs.filter(function (tx) { return !tx.block || tx.block.hash !== block_hash; }) });
                            }
                            return [2 /*return*/, data];
                    }
                });
            });
        },
        getCurrentBlock: function () {
            return __awaiter(this, void 0, void 0, function () {
                var data;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, network_1["default"])({
                                method: "GET",
                                url: "".concat(baseURL, "/blocks/current"),
                                transformResponse: json_bignumber_1["default"].parse
                            })];
                        case 1:
                            data = (_a.sent()).data;
                            return [2 /*return*/, data];
                    }
                });
            });
        },
        getAccountNonce: function (address) {
            return __awaiter(this, void 0, void 0, function () {
                var data;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, network_1["default"])({
                                method: "GET",
                                url: "".concat(baseURL, "/addresses/").concat(address, "/nonce")
                            })];
                        case 1:
                            data = (_a.sent()).data;
                            return [2 /*return*/, data[0].nonce];
                    }
                });
            });
        },
        broadcastTransaction: function (tx) {
            return __awaiter(this, void 0, void 0, function () {
                var data;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, network_1["default"])({
                                method: "POST",
                                url: "".concat(baseURL, "/transactions/send"),
                                data: {
                                    tx: tx
                                }
                            })];
                        case 1:
                            data = (_a.sent()).data;
                            return [2 /*return*/, data.result];
                    }
                });
            });
        },
        getAccountBalance: function (address) {
            return __awaiter(this, void 0, void 0, function () {
                var data;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, network_1["default"])({
                                method: "GET",
                                url: "".concat(baseURL, "/addresses/").concat(address, "/balance"),
                                transformResponse: json_bignumber_1["default"].parse
                            })];
                        case 1:
                            data = (_a.sent()).data;
                            return [2 /*return*/, new bignumber_js_1.BigNumber(data[0].balance)];
                    }
                });
            });
        },
        getERC20Balances: function (input) {
            return __awaiter(this, void 0, void 0, function () {
                var data;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, network_1["default"])({
                                method: "POST",
                                url: "".concat(baseURL, "/erc20/balances"),
                                transformResponse: json_bignumber_1["default"].parse,
                                data: input
                            })];
                        case 1:
                            data = (_a.sent()).data;
                            return [2 /*return*/, data];
                    }
                });
            });
        },
        getNFTMetadata: function (input) {
            return __awaiter(this, void 0, void 0, function () {
                var data;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, network_1["default"])({
                                method: "POST",
                                url: (0, env_1.getEnv)("NFT_ETH_METADATA_SERVICE") +
                                    "/v1/ethereum/1/contracts/tokens/infos",
                                data: input
                            })];
                        case 1:
                            data = (_a.sent()).data;
                            return [2 /*return*/, data];
                    }
                });
            });
        },
        getERC20ApprovalsPerContract: function (owner, contract) {
            return __awaiter(this, void 0, void 0, function () {
                var data, e_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, (0, network_1["default"])({
                                    method: "GET",
                                    url: url_1["default"].format({
                                        pathname: "".concat(baseURL, "/erc20/approvals"),
                                        query: {
                                            owner: owner,
                                            contract: contract
                                        }
                                    })
                                })];
                        case 1:
                            data = (_a.sent()).data;
                            return [2 /*return*/, data
                                    .map(function (m) {
                                    if (!m || typeof m !== "object")
                                        return;
                                    var sender = m.sender, value = m.value;
                                    if (typeof sender !== "string" || typeof value !== "string")
                                        return;
                                    return {
                                        sender: sender,
                                        value: value
                                    };
                                })
                                    .filter(Boolean)];
                        case 2:
                            e_1 = _a.sent();
                            if (e_1.status === 404) {
                                return [2 /*return*/, []];
                            }
                            throw e_1;
                        case 3: return [2 /*return*/];
                    }
                });
            });
        },
        roughlyEstimateGasLimit: function (address) {
            return __awaiter(this, void 0, void 0, function () {
                var data;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, network_1["default"])({
                                method: "GET",
                                url: "".concat(baseURL, "/addresses/").concat(address, "/estimate-gas-limit"),
                                transformResponse: json_bignumber_1["default"].parse
                            })];
                        case 1:
                            data = (_a.sent()).data;
                            return [2 /*return*/, new bignumber_js_1.BigNumber(data.estimated_gas_limit)];
                    }
                });
            });
        },
        getDryRunGasLimit: function (address, request) {
            return __awaiter(this, void 0, void 0, function () {
                var post, data, value;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            post = __assign({}, request);
                            // .to not needed by backend as it's part of URL:
                            delete post.to;
                            // backend use gas_price casing:
                            post.gas_price = request.gasPrice;
                            delete post.gasPrice;
                            return [4 /*yield*/, (0, network_1["default"])({
                                    method: "POST",
                                    url: "".concat(baseURL, "/addresses/").concat(address, "/estimate-gas-limit"),
                                    data: post,
                                    transformResponse: json_bignumber_1["default"].parse
                                })];
                        case 1:
                            data = (_a.sent()).data;
                            if (data.error_message) {
                                throw new errors_2.FeeEstimationFailed(data.error_message);
                            }
                            value = new bignumber_js_1.BigNumber(data.estimated_gas_limit);
                            (0, invariant_1["default"])(!value.isNaN(), "invalid server data");
                            return [2 /*return*/, value];
                    }
                });
            });
        },
        getGasTrackerBarometer: (0, cache_1.makeLRUCache)(function () { return __awaiter(void 0, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, (0, network_1["default"])({
                            method: "GET",
                            url: "".concat(baseURL, "/gastracker/barometer")
                        })];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, {
                                low: new bignumber_js_1.BigNumber(data.low),
                                medium: new bignumber_js_1.BigNumber(data.medium),
                                high: new bignumber_js_1.BigNumber(data.high)
                            }];
                }
            });
        }); }, function () { return ""; }, {
            maxAge: 30 * 1000
        })
    };
};
exports.apiForCurrency = apiForCurrency;
//# sourceMappingURL=Ethereum.js.map